// extracted by mini-css-extract-plugin
export default {"wrapper":"input-filter_wrapper__aMvZP"};